var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16699 1.66663C5.02486 1.66663 1.66699 5.02449 1.66699 9.16663C1.66699 13.3088 5.02486 16.6666 9.16699 16.6666C10.9378 16.6666 12.5653 16.0529 13.8484 15.0265L16.9111 18.0892C17.2365 18.4147 17.7641 18.4147 18.0896 18.0892C18.415 17.7638 18.415 17.2361 18.0896 16.9107L15.0269 13.848C16.0533 12.565 16.667 10.9375 16.667 9.16663C16.667 5.02449 13.3091 1.66663 9.16699 1.66663ZM3.33366 9.16663C3.33366 5.94497 5.94533 3.33329 9.16699 3.33329C12.3887 3.33329 15.0003 5.94497 15.0003 9.16663C15.0003 12.3883 12.3887 15 9.16699 15C5.94533 15 3.33366 12.3883 3.33366 9.16663Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.0a6dfd6f497274885683f3fcc2548670.svg";
export { ForwardRef as ReactComponent };